WiseMetering.Views.IndexInvoice = WiseMetering.Views.TableIndex.extend({
    icon: 'invoices',
    name: () => i18next.t('glossary.invoices'),

    POLL_INTERVAL_MS: 2000,
    PROCESSING_TIMEOUT_MS: 60 * 60 * 1000,

    createTable: function createTable() {
        const collection = WiseMetering.invoices.filterByUtility(this.model);
        this.listenTo(collection, 'add', function(invoice) {
            WiseMetering.invoices.add(invoice);
        });

        return new WiseMetering.Views.Table({
            id: 'invoice',
            collection: collection,
            modelSerializer: model => {
                const
                    json = model.toJSON(),
                    timezone = WiseMetering.zones.get(json.site_id).get('timezone'),
                    utilityKind = WiseMetering.utilityKinds.get(json.utility_kind_id);

                json.start ||= '-';
                json.consumption = json.consumption !== null && json.consumption !== undefined ? Lmit.Utils.formatNumber(json.consumption, utilityKind.unit()) : '-';
                json.cost = json.cost !== null && json.cost !== undefined ? Lmit.Utils.formatNumber(json.cost, WiseMetering.getCurrency()) : '-';
                json.creatorName = json.creator_name;
                json.created = WiseMetering.utils.formatDate(json.created_at, timezone, 'YYYY/MM/DD HH:mm');
                json.finish ||= '-';
                json.utility_kind = i18next.t(`utility_kinds.${utilityKind.get('slug')}`).capitalize();

                json.file = json.file && model.fileLink();
                json._pendingPriority = json.status === 'pending' ? 0 : 1;
                json.status = {
                    color: WiseMetering.Colors[model.statusColor()],
                    title: model.invoiceValidationStatus()
                };

                return json;
            },
            columns: {
                _pendingPriority: {
                    bVisible: false,
                    orderable: false
                },
                reference: {
                    title: `${i18next.t('common.reference')}?`,
                    className: 'table-icon center',
                    width: '5%',
                    mRender: function(reference) {
                        if (reference === false) {
                            return '';
                        }
                        return WiseMetering.icon('check');
                    }
                },
                status: {
                    title: `${i18next.t('common.validation')}?`,
                    className: 'table-icon center',
                    width: '5%',
                    mRender: status => JST['templates/ui/components/circle']({
                        color: status.color,
                        title: status.title
                    })
                },
                file: {
                    title: `${i18next.t('common.file')}?`,
                    className: 'table-icon center file',
                    width: '5%',
                    mRender: function(file) {
                        if (!file) {
                            return '';
                        }
                        return `<a class='link' href='${file}' target='_blank'>${WiseMetering.icon('file')}</a>`;
                    }
                },
                start: {
                    title: i18next.t('invoices.start'),
                    className: 'center'
                },
                finish: {
                    title: i18next.t('invoices.finish'),
                    className: 'center',
                    width: '10%'
                },
                consumption: {
                    title: i18next.t('common.consumption'),
                    className: 'align-right',
                    width: '10%'
                },
                cost: {
                    title: i18next.t('common.cost'),
                    className: 'align-right',
                    width: '10%'
                },
                creatorName: {
                    title: i18next.t('glossary.created_by'),
                    className: 'center',
                    width: '10%'
                },
                created: {
                    title: i18next.t('glossary.created_at'),
                    className: 'center',
                    width: '10%'
                }
            },
            sort: {
                column: 'start',
                order: 'desc'
            },
            orderFixed: [[1, 'asc']],
            toolbar_actions: {
                new: {
                    view_call: () => new WiseMetering.Views.NewInvoice({ collection, model: new WiseMetering.Model.Invoice({ utility_id: this.model.id }) })
                },
                upload: {
                    label: i18next.t('invoices.upload_pdfs'),
                    view_call: () => new WiseMetering.Views.UploadInvoices({ model: this.model })
                },
                edit: {
                    view_call: model => new WiseMetering.Views.EditInvoice({ model })
                },
                delete: {
                    view_call: model => new WiseMetering.Views.DestroyInvoice({ model })
                },
                show: {
                    view_call: model => new WiseMetering.Views.ShowInvoice({ model })
                }
            }
        });
    },

    onShow: function() {
        WiseMetering.Views.TableIndex.prototype.onShow.call(this);

        $('#invoice tbody').on('click', `td.file .fa-file`, function(event) {
            event.stopPropagation();
        }.bind(this));

        this.bindEvents();
        this.setupDropZone();
        this.startPollingIfNeeded();
    },

    bindEvents: function() {
        if (this._eventsBound) {
            return;
        }
        this._eventsBound = true;
        this.listenTo(WiseMetering.invoices, 'add change remove', this.onInvoicesChanged.bind(this));
    },

    onInvoicesChanged: function() {
        this.rebuildTable();
    },

    rebuildTable: function() {
        if (this.isClosed || !this.body) {
            return;
        }
        if (this.table && this.table.remove) {
            this.table.remove();
        }
        this.table = this.createTable();
        $(this.body.el).html(this.table.el);
        this.startPollingIfNeeded();
    },

    hasProcessingInvoices: function() {
        const now = Date.now();
        const utilityId = this.model.id;
        return WiseMetering.invoices.some(invoice => {
            if (invoice.get('utility_id') !== utilityId) {
                return false;
            }
            if (invoice.get('status') !== 'pending') {
                return false;
            }
            const createdAtMs = invoice.get('created_at') * 1000;
            return (now - createdAtMs) < this.PROCESSING_TIMEOUT_MS;
        });
    },

    pollProcessingInvoices: function() {
        if (!this.hasProcessingInvoices()) {
            this.stopPolling();
            return;
        }
        WiseMetering.invoices.fetch({
            complete: () => {
                if (!this.hasProcessingInvoices()) {
                    this.stopPolling();
                }
            }
        });
    },

    startPollingIfNeeded: function() {
        if (this._poller) {
            return;
        }
        if (!this.hasProcessingInvoices()) {
            return;
        }
        this._poller = setInterval(() => this.pollProcessingInvoices(), this.POLL_INTERVAL_MS);
    },

    stopPolling: function() {
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    },

    setupDropZone: function() {
        this.dropZone = new WiseMetering.Views.Ui.DropZone({
            $container: $(this.body.el).closest('.panels_container.regular'),
            message: i18next.t('invoices.drop_pdf_files_here'),
            onDrop: files => this.uploadFiles(files)
        });
    },

    showUploadOverlay: function(count) {
        if (this.dropZone) {
            this.dropZone.show(i18next.t('invoices.uploading_files', { count }), { spinner: true });
        }
    },

    hideUploadOverlay: function() {
        if (this.dropZone) {
            this.dropZone.hide(i18next.t('invoices.drop_pdf_files_here'));
        }
    },

    showUploadCompleteOverlay: function() {
        if (!this.dropZone) {
            return;
        }
        clearTimeout(this._uploadCompleteTimeout);
        this.dropZone.success(i18next.t('invoices.bulk_upload_email_notification_pending'));
        this._uploadCompleteTimeout = setTimeout(() => this.hideUploadOverlay(), 4500);
    },

    uploadFiles: function(fileList) {
        const files = Array.from(fileList), maxFiles = WiseMetering.Views.UploadInvoices.MAX_FILES;

        if (files.length === 0) {
            return;
        }

        if (files.some(file => file.type !== 'application/pdf')) {
            WiseMetering.layout.showTipper('error', i18next.t('invoices.pdf_files_only'));
            return;
        }

        if (files.length > maxFiles) {
            WiseMetering.layout.showTipper('error', i18next.t('invoices.max_files_exceeded', { count: maxFiles }));
            return;
        }

        this.showUploadOverlay(files.length);

        WiseMetering.Views.UploadInvoices.upload(this.model.id, files).done(function(response) {
            if (this.isClosed) {
                return;
            }
            this.showUploadCompleteOverlay();
            WiseMetering.layout.showTipper('success', i18next.t('invoices.bulk_upload_success', { count: response.invoice_ids.length }));
            WiseMetering.invoices.fetch({
                complete: () => {
                    this.startPollingIfNeeded();
                }
            });
        }.bind(this)).fail(function(response) {
            if (this.isClosed) {
                return;
            }
            this.hideUploadOverlay();
            WiseMetering.layout.showTipper('error', WiseMetering.Views.UploadInvoices.errorMessage(response), 5000);
        }.bind(this));
    },

    onClose: function() {
        this.stopPolling();
        clearTimeout(this._uploadCompleteTimeout);
        if (this.dropZone) {
            this.dropZone.remove();
        }
        WiseMetering.Views.TableIndex.prototype.onClose && WiseMetering.Views.TableIndex.prototype.onClose.call(this);
    }
});
